'use client'

import { Button, Tooltip } from '@sylveraio/design-system'
import LogOut01 from '@sylveraio/untitled-ui-icons-react/build/esm/LogOut01'
import { FC } from 'react'
import { useLogout } from '../utils/useLogout'

export const Logout: FC = () => {
  const logout = useLogout()

  const handleLogout = async () => {
    await logout()
  }

  return (
    <Tooltip title="Log out" condensed subtle={false} placement="right">
      <Button
        iconLeading={<LogOut01 />}
        variant="secondary"
        size="xs"
        onClick={handleLogout}
      />
    </Tooltip>
  )
}
